import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EmailEditor from '../../helpers/email-editor/EmailEditor';
import useEmailEditorStore from '../../helpers/email-editor/utilities/emailEditorStore';
import { htmlExport } from '../../helpers/email-editor/utilities/htmlExport';
import templateService from '../../../services/template.service';
import { toast } from 'react-toastify';

function AddEmailTemplate() {
    const [templateTypes, setTemplateTypes] = useState([]);
    const [txtType, setTxtType] = useState('PREBOOKED_REMINDER');
    const [txtUsedBy, settxtUsedBy] = useState('CLINIC');
    const [txtSubject, setTxtSubject] = useState('');
    const navigate = useNavigate();
    const { blocks, globalProperties, exportTemplate } = useEmailEditorStore();

    const handletxtTypeChange = (event) => {
        setTxtType(event.target.value);
    };

    const handletxtUsedByChange = (event) => {
        settxtUsedBy(event.target.value);
    };

    const handleTextChange = (event) => {
        setTxtSubject(event.target.value);
    };

    const exportHtml = () => {
        try {
            const html = htmlExport(blocks, globalProperties);
            const template = exportTemplate();
            const jsonString = JSON.stringify(template);

            const edata = {
                type: txtType,
                mediumType: 'EMAIL',
                subjectLine: txtSubject,
                content: html,
                jsonContent: jsonString,
                usedBy: txtUsedBy,
            };

            templateService
                .saveEcxTemplate(1, edata)
                .then(() => {
                    toast.success('Successfully Added New Template.', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    navigate('/email-template');
                })
                .catch((err) => {
                    toast.error('Cannot Create New Template.', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    console.error(err);
                });
        } catch (error) {
            toast.error('Error exporting template.', {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
            console.error(error);
        }
    };

    useEffect(() => {
        templateService
            .getTemplateTypes()
            .then((res) => setTemplateTypes(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <div className="container container-xxl">
            <nav className="navbar mb-3 navbar-expand-lg rounded p-3" style={{ backgroundColor: '#8b02ee' }}>
                <div className="container-fluid">
                    <div className="d-flex flex-column me-4">
                        <span className="navbar-brand" style={{ color: 'white' }}>
                            Email Template
                        </span>
                    </div>

                    <div className="d-flex flex-column">
                        <div className="row">
                            <div className="col-4">
                                <label htmlFor="" className="form-label" style={{ color: 'white' }}>
                                    Select Template
                                </label>
                            </div>
                            <div className="col-8">
                                <select
                                    className="form-select form-select-sm"
                                    onChange={handletxtTypeChange}
                                    value={txtType}
                                >
                                    {templateTypes.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-4">
                                <label htmlFor="" className="form-label" style={{ color: 'white' }}>
                                    Used By
                                </label>
                            </div>
                            <div className="col-8">
                                <select
                                    className="form-select form-select-sm"
                                    onChange={handletxtUsedByChange}
                                    value={txtUsedBy}
                                >
                                    <option value="CLINIC">Clinic</option>
                                    <option value="ECX">EyeconX</option>
                                </select>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-3">
                                <label htmlFor="" className="form-label me-2" style={{ color: 'white' }}>
                                    Subject
                                </label>
                            </div>
                            <div className="col-9">
                                <input
                                    type="text"
                                    minLength={3}
                                    onChange={handleTextChange}
                                    value={txtSubject}
                                    className="form-control form-control-sm"
                                />
                            </div>
                        </div>

                        <div className="d-flex justify-content-between mt-2">
                            <button type="button" className="btn btn-sm btn-warning ms-2" onClick={exportHtml}>
                                Save
                            </button>
                            <button
                                type="button"
                                className="btn btn-sm btn-success ms-2"
                                onClick={() => navigate('/email-template')}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            <div className="row">
                <div className="col-12">
                    <EmailEditor emailSubject={txtSubject} />
                </div>
            </div>
        </div>
    );
}

export default AddEmailTemplate;
